import { PayloadAction } from 'typesafe-actions';
import { AliasContextActionTypes, AliasState } from './types';

const AliasReducer = (state: AliasState, action: PayloadAction<AliasContextActionTypes, any>): AliasState => {
  switch (action.type) {
    case AliasContextActionTypes.SetAliasAction:
      return {
        ...state,
        action: action.payload.action,
        alias: action.payload.alias,
      };

    case AliasContextActionTypes.SetSelectedAccountForAction:
      return {
        ...state,
        selectedAccountForAction: action.payload,
      };

    case AliasContextActionTypes.ResetSelectedAccountForAction:
      return {
        ...state,
        selectedAccountForAction: null,
        action: null,
      };

    default: {
      return state;
    }
  }
};

export { AliasReducer };
